type EarlyClickWindow = Window & { __earlyClicks?: HTMLElement[] }

/**
 * Called once React has hydrated the server-rendered page: marks the page as live (the inline script in <head>,
 * earlyClicks.inline.js, stops holding clicks) and replays, in order, each click it held while the page was not yet
 * interactive — so an early click is never a dead one (F13b, re-walk N14).
 */
export function markHydrated(win: EarlyClickWindow = window) {
  const root = win.document.documentElement
  root.setAttribute('data-hydrated', '')
  const held = win.__earlyClicks ?? []
  win.__earlyClicks = []
  root.removeAttribute('data-early-click')
  for (const element of held) {
    if (element.isConnected && !(element as HTMLButtonElement).disabled) element.click()
  }
}
